import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

type Result = {
	data: {
		canEdit: boolean;
		updateHref: string;
	};
};

export function useNewUpdateCta(): Result {
	const {
		data: {
			petition: { slug },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { canEdit },
	} = usePetitionDetailsPageUserData();

	const updateHref = `/p/${slug}/dashboard/updates`;

	return {
		data: { canEdit, updateHref },
	};
}
